import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

import { ChangePasswordModel } from '../../../models/account';
import { MessageService, AccountService } from '../../../services';
import { CurrentUserProfile } from '../../../models/account';
import { AppUtils } from '../../../helpers';

@Component({
    selector: 'Header',
    templateUrl: './header.component.html'
})

export class HeaderComponent implements OnInit {
    @BlockUI('conatiner-change-password') blockUI: NgBlockUI;

    isUserAuthenticated = false;
    userProfile: CurrentUserProfile = new CurrentUserProfile();

    filterKey: string = null;
    filterType = 'contest';
    modalReference: any;
    changePasswordModel: ChangePasswordModel = new ChangePasswordModel();

    constructor(private vcr: ViewContainerRef,
        private toastr: ToastsManager,
        private router: Router,
        private modalService: NgbModal,
        private _messageService: MessageService,
        private _accountService: AccountService,
        private appUtils: AppUtils) {
        this.toastr.setRootViewContainerRef(this.vcr);
        this._messageService.listen().subscribe(() => {
            this.loadCurrentUserProfile();
        });
    }

    loadCurrentUserProfile() {
        this._accountService.getCurrentUserProfile()
            .subscribe(
                (data: any) => {
                    Object.assign(this.userProfile, data);
                    this.isUserAuthenticated = true;
                },
                error => {
                    if (error.status !== 401) {
                        console.log(error);
                        return;
                    }
                    this.isUserAuthenticated = false;
                });
    }

    ngOnInit() {
        this.loadCurrentUserProfile();
    }

    onFilterTypeChange() {
        this.filterKey = null;
    }

    filterContest() {
        switch (this.filterType) {
            case 'creation':
                this.router.navigate(['/creation/filter'], { queryParams: { q: this.filterKey } });
                break;
            case 'creator':
                this.router.navigate(['/creator/filter'], { queryParams: { q: this.filterKey } });
                break;
            default:
                this.router.navigate(['/contest/filter'], { queryParams: { q: this.filterKey } });
        }
    }

    openChangePasswordModal(content: any) {
        this.changePasswordModel = new ChangePasswordModel();
        this.modalReference = this.modalService.open(content);
    }

    closeChangePasswordModal() {
        this.modalReference.close();
    }

    changePassword() {
        this.blockUI.start();
        this._accountService.changePassword(this.changePasswordModel).subscribe(
            () => {
                this.toastr.success('Your password has been changed successfully.');
                this.blockUI.stop();
                this.closeChangePasswordModal();
            },
            error => {
                this.blockUI.stop();
                this.appUtils.ProcessErrorResponse(this.toastr, error);
            });
    }
}



// WEBPACK FOOTER //
// ./src/components/shared/header/header.component.ts